import { Row, Col, Skeleton, Tooltip,message } from "antd";
import { RiUserSearchFill } from "react-icons/ri";
import axios from "axios";
import classes from "../Pages.module.css";
import { useState, useEffect, useContext } from "react";
import DataContext from "../../../Context/dataContext";
import EmployeeTable from "../EmployeeTable/EmployeeTable";
import { AiFillDelete } from "react-icons/ai";
import { getFormPermissions} from '../../../utils/checkDayPermission';
import { Link } from "react-router-dom";

const ContractDetail = (props) => {
  const employeeData = useContext(DataContext);
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState(null);
  // const [drows, setDRows] = useState(null);
  const { canAdd, canModify, canDelete, canQuery, messages } = getFormPermissions("Vendor Master", employeeData);

  

  useEffect(() => {
    // setDRows(null);
    setRows(null);
    setColumns([]);

    axios
      .get(employeeData.URL + "/api/v1/vender", {
        withCredentials: true,
      })
      .then((response) => {
        // console.log(response);

        setColumns((columns) => {
          let newCols = response.data.data.sauda.fields.map((col) => {
            return {
              name: col.name,
              title: col.name.split("_").join(" ").toLowerCase(),
            };
          });

          const newNewCols = [
            { name: "D", title: "D" },
            { name: "V", title: "V" },
            { name: "SNO", title: "SNo" },
            ...newCols,
          ];
          return newNewCols;
        });

        setRows((rows) => {
          let newRows = response.data.data.sauda.rows.map((row, index) => {
            return {
              D: canDelete ? (
                <Tooltip placement="bottom" title="Delete" color="red">
                  <Link to="#" style={{ color: "red", fontWeight: "bolder" }}>
                    <AiFillDelete
                      onClick={(event) =>
                        deleteHandler(
                          event,
                          index,
                          response.data.data.sauda.rows,
                          row["vendor_code"]
                        )
                      }
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ): (
                <Tooltip 
                  placement="bottom" 
                  title={messages.delete}
                  color="red"
                >
                  <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                    <AiFillDelete
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </span>
                </Tooltip>
              ),
              V:canModify ? (
                <Tooltip placement="bottom" title="View" color="#1777C4">
                  <Link
                    to={
                      "/purchase/vender-master/vendor-view/" +
                      row["vendor_code"]
                    }
                    style={{ color: "#1777C4", fontWeight: "bolder" }}
                  >
                    <RiUserSearchFill
                      style={{
                        color: "#1777C4",
                        fontWeight: "bolder",
                        fontSize: "0.9rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ): (
                <Tooltip 
                  placement="bottom" 
                  title={messages.query}
                  color="#1777C4"
                >
                  <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                    <RiUserSearchFill
                      style={{
                        color: "#1777C4",
                        fontWeight: "bolder",
                        fontSize: "0.9rem",
                      }}
                    />
                  </span>
                </Tooltip>
              ),

              SNO: index + 1,
              ...row,
            };
          });
          return newRows;
        });
      })
      .catch((error) => {
        // console.log(error);
      });
  }, [employeeData, canDelete, canQuery]);

  const deleteHandler = (event, index, newrows, code) => {
    if (!canDelete) {
      message.warning(messages.delete || "You don't have permission to delete items.");
      return;
    }
    // console.log(index);
    console.log(newrows,"newwwwwrows");


    setRows(null);
    axios
      .delete(employeeData.URL + "/api/v1/vender/" + code.toString(), {
        withCredentials: true,
      })
      .then((response) => {
        // console.log(response);
        const { message: backendMessage, isUsed } = response.data; // Extract message from the backend

        // Show success or warning message from backend using Ant Design message component
        if (response.data.status === "success") {
          message.success(backendMessage); // Show success message
        } else {
          message.warning(backendMessage); // Show warning message
        }

        // Only filter out the row if the item is not used (isUsed is false)
        let rowvals = newrows;
        if (!isUsed) {
          rowvals = newrows.filter((row) => row["vendor_code"] !== code);
        }
        
        setRows((rows) => {
          let newDRows = rowvals.map((row, index) => {
            return {
              D:canDelete ? (
                <Tooltip placement="bottom" title="Delete" color="red">
                  <Link to="#" style={{ color: "red", fontWeight: "bolder" }}>
                    <AiFillDelete
                      onClick={(event) =>
                        deleteHandler(event, index, rowvals, row["vendor_code"])
                      }
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ): (
                <Tooltip 
                  placement="bottom" 
                  title={messages.delete}
                  color="red"
                >
                  <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                    <AiFillDelete
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </span>
                </Tooltip>
              ),
              V:canModify ? (
                <Tooltip placement="bottom" title="View" color="#1777C4">
                  <Link
                    to={
                      "/purchase/vender-master/vendor-view/" +
                      row["vendor_code"]
                    }
                    style={{ color: "#1777C4", fontWeight: "bolder" }}
                  >
                    <RiUserSearchFill
                      style={{
                        color: "#1777C4",
                        fontWeight: "bolder",
                        fontSize: "0.9rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ): (
                <Tooltip 
                  placement="bottom" 
                  title="You don't have permission to view items" 
                  color="#1777C4"
                >
                  <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                    <RiUserSearchFill
                      style={{
                        color: "#1777C4",
                        fontWeight: "bolder",
                        fontSize: "0.9rem",
                      }}
                    />
                  </span>
                </Tooltip>
              ),

              SNO: index + 1,
              ...row,
            };
          });
          return newDRows;
        });
      })
      .catch((error) => {
        setRows((rows) => {
          let newDRows = newrows.map((row, index) => {
            return {
              D:canDelete ? (
                <Tooltip placement="bottom" title="Delete" color="red">
                  <Link to="#" style={{ color: "red", fontWeight: "bolder" }}>
                    <AiFillDelete
                      onClick={(event) =>
                        deleteHandler(event, index, newrows, row["vendor_code"])
                      }
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ): (
                <Tooltip 
                  placement="bottom" 
                  title={messages.delete}
                  color="red"
                >
                  <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                    <AiFillDelete
                      style={{
                        color: "red",
                        fontWeight: "bolder",
                        fontSize: "0.8rem",
                      }}
                    />
                  </span>
                </Tooltip>
              ),
              V: canModify ? (
                <Tooltip placement="bottom" title="View" color="#1777C4">
                  <Link
                    to={
                      "/purchase/vender-master/vendor-view/" +
                      row["vendor_code"]
                    }
                    style={{ color: "#1777C4", fontWeight: "bolder" }}
                  >
                    <RiUserSearchFill
                      style={{
                        color: "#1777C4",
                        fontWeight: "bolder",
                        fontSize: "0.9rem",
                      }}
                    />
                  </Link>
                </Tooltip>
              ): (
                <Tooltip 
                  placement="bottom" 
                  title="You don't have permission to view items" 
                  color="#1777C4"
                >
                  <span style={{ opacity: 0.5, cursor: 'not-allowed' }}>
                    <RiUserSearchFill
                      style={{
                        color: "#1777C4",
                        fontWeight: "bolder",
                        fontSize: "0.9rem",
                      }}
                    />
                  </span>
                </Tooltip>
              ),

              SNO: index + 1,
              ...row,
            };
          });
          return newDRows;
        });
        // console.log(error);
      });
  };

  return (
    <>
      <Row className={classes["Row"]}>
        <Col md={14}>
          <p className={classes["Title"]}>All Vendor Details</p>
        </Col>
        <Col className={classes["Col"]} md={10}></Col>
      </Row>
      <p></p>
      <Row className={classes["Row"]}>
        <Col lg={19} md={17}></Col>
        <Col className={classes["Col"]} lg={5} md={7}>
        <Tooltip 
            placement="bottom" 
            title={!canAdd ? messages.add : ""}
          >
          <Link to={canAdd ? "/purchase/venderMaster/create-vender" : "#"}
            onClick={(e) => !canAdd && e.preventDefault()}
                      >
            <button 
            disabled={!canAdd}
            className={classes["ProfileButton"]}
            style={{
             opacity: canAdd ? 1 : 0.5,
             cursor: canAdd ? 'pointer' : 'not-allowed'
             }}>
              New Vendor</button>
          </Link>
          </Tooltip>
        </Col>
      </Row>
      <p></p>
      {rows && columns.length > 0 ? (
        <>
          <EmployeeTable data={rows} columns={columns} val={true} />
        </>
      ) : (
        <>
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
          <Skeleton active={true} />
        </>
      )}
    </>
  );
};

export default ContractDetail;
